module.exports = __webpack_public_path__ + "static/img/white_plus.d6362a95.svg";